import React from 'react';
import { FormHelperText, Grid, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import FolioCheckbox from '@/components/FolioCheckbox';
import { USER_FIELD_LABELS, USER_PERMISSION_FIELDS } from '../userFormValues';

/**
 * The user edit drawer's Permissions section, as FolioCheckboxes. Admins can't change their
 * own Folio admin access. A Folio admin change applies from the user's next sign-in, when
 * their token is created.
 */
export const PermissionFields = ({ userId }) => {
	const { values, errors, setFieldValue } = useFormikContext();
	const email = useSelector((state) => state.msalAccount.account?.username);
	const { data: currentUser } = useGetUserDetailsQuery({ email }, { skip: !email });
	const isSelf = currentUser?.userId === userId;

	return (
		<>
			<Grid size={12}>
				<Typography variant='form_label'>Permissions</Typography>
			</Grid>
			{USER_PERMISSION_FIELDS.map((field) => (
				<Grid key={field} size={{ xs: 12, sm: 4 }}>
					<FolioCheckbox
						checked={values[field]}
						onChange={(event) => setFieldValue(field, event.target.checked)}
						disabled={field === 'isFolioAdmin' && isSelf}
						label={USER_FIELD_LABELS[field]}
						{...(field === 'isFolioAdmin' &&
							isSelf && {
								sublabel: 'You cannot change your own Folio admin access',
							})}
					/>
					{errors[field] && <FormHelperText error>{errors[field]}</FormHelperText>}
				</Grid>
			))}
		</>
	);
};
